<template>
<v-layout :id="listId" row justify-start pt-2 pb-2 @click="clicked" class="pointer">
  <v-icon v-if="isSelected" color="primary" class="mr-1">mdi-check</v-icon>
  <v-icon v-else class="mr-1">mdi-blank</v-icon>
  <div class="prevent-overflow" style="overflow: hidden">
    <div v-for="(subRow, i) in row.rows" :key="`flist-${row.id}-${i}`">
      {{subRow}}
    </div>
  </div>
</v-layout>
</template>

<script>
export default {
  name: 'filter-list-row',
  props: {
    row: {
      type: Object,
      required: true
    },
    idSet: {
      type: Set,
      required: true
    },
    rowKey: {
      type: Number
    }
  },
  methods: {
    clicked () {
      this.$emit('selected', {id: this.row.id, selected: !this.isSelected})
    }
  },
  computed: {
    isSelected () {
      return this.idSet.has(this.row.id)
    },
    listId () {
      return `selection-${this.rowKey}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/FilterListRow.vue